import { newRequest } from "std/api/newRequest";
import type { ApiRelatorioGetParams } from "../types/ApiRelatorioParams";
import type { ApiRelAnaliseQualidadeResponse } from "../types/ApiRelAnaliseQualidade";

export function apiRelAnaliseQualidade({
	params,
}: {
	params: ApiRelatorioGetParams;
}): Promise<ApiRelAnaliseQualidadeResponse> {
	return newRequest({
		url: "Relatorio/AnaliseQualidade",
		type: "get",
		idpk: undefined,
		params,
	});
}
